import React, { useState, useEffect, KeyboardEvent } from 'react'
import { useRouter } from 'next/router'
import normalizeQuery from '@utilities/functions/normalizeQuery'
import { FaTrash } from 'react-icons/fa'
import { PositionType } from '@components/Location/location.types'

const LocationSearchByZip: React.FC<{
  zipCodePosition: PositionType | null
}> = ({ zipCodePosition }) => {
  const router = useRouter()
  const initialZipCode = normalizeQuery(router.query.zipCode)
  const [zipCode, setZipCode] = useState<string>(initialZipCode || '')

  const urlZipCode = normalizeQuery(router.query.zipCode)
  const isValid = /^\d{5}$/.test(zipCode)

  const showReset = urlZipCode
  const isDisabled = !isValid

  useEffect(() => {
    setZipCode(initialZipCode || '')
  }, [initialZipCode])

  const handleSearch = async () => {
    await router.push(`?zipCode=${zipCode}`)
  }

  const handleClear = async () => {
    await router.push(`/location`)
  }

  const handleKeyDown = async (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !isDisabled) {
      await handleSearch()
    }
  }

  const invalidZipcode = Boolean(initialZipCode && !zipCodePosition)

  return (
    <div className="flex flex-row gap-2 justify-center items-center">
      <p className="font-bold text-sm hidden md:block">
        ENTER YOUR{' '}
        {invalidZipcode && (
          <span className={'font-bold italic text-bidfta-red'}>VALID </span>
        )}
        ZIP CODE
      </p>
      <div className="relative w-40">
        <input
          type="text"
          value={zipCode}
          onChange={(e) => setZipCode(e.target.value)}
          className={`p-2 pr-8 border rounded-md w-full ${
            invalidZipcode
              ? 'border-bidfta-red focus:outline-none focus:text-bidfta-red'
              : ''
          }`}
          placeholder="Enter Zip Code"
          onKeyDown={handleKeyDown}
        />
        {showReset && (
          <button
            data-testid="location-reset-search-button"
            disabled={isDisabled}
            onClick={handleClear}
            className={`absolute top-1/2 transform -translate-y-1/2 right-2 flex items-center justify-center text-red text-md ${
              !isValid && !urlZipCode ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <FaTrash />
          </button>
        )}
      </div>
      <button
        data-testid="location-search-button"
        disabled={isDisabled}
        onClick={handleSearch}
        className={`px-6 bg-bidfta-blue-light text-white rounded-md text-sm h-8 ${
          isDisabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        SEARCH
      </button>
    </div>
  )
}

export default LocationSearchByZip
